module.exports = __webpack_public_path__ + "img/peter-madsen.6bd428da.png";